const logger = {
  log: (...args) => {
    if (
      process.env.NODE_ENV !== "production" ||
      (typeof window !== "undefined" && window.debug)
    ) {
      return console.log(...args);
    }
  },
  warn: (...args) => {
    if (
      process.env.NODE_ENV !== "production" ||
      (typeof window !== "undefined" && window.debug)
    ) {
      return console.warn(...args);
    }
  },
  info: () => {},
  error: (...args) => {
    if (
      process.env.NODE_ENV !== "production" ||
      (typeof window !== "undefined" && window.debug)
    ) {
      return console.error(...args);
    }
  },
};
module.exports = logger;
